export default {
    login:{
        account:'用户名',
        password:'密码',
        login:'登录',
        reset:'重置',
        inputAccount:"请输入用户名!",
        inputPassword:'请输入密码!',
        lengthInvalid:'密码长度在8-16个字符之间!',
        loginFaild:'登陆失败',
        Message:{
            Duplicate_Requests:'请求过于频繁,请稍后再试',
            Invalid_Account:'账户不存在',
            Incorrect_AccountOrPassword:'账号或密码错误',
            PermissionDenied:'权限拒绝'
        }
    },
    startPage:{
        title:'Vue 学习'
    },
    menu:{
        home:'主页',
        Management:'管理',
        Personnel:'人员管理',
        Organization:'组织管理',
        License:'证书管理',
        Application:'应用管理',
        Menu1:'菜单',
        HelloWorld:'你好世界',
        Login:'登录'
    },
    userMenu:{
        Setting:'设置',
        Exit:'退出',
        confirmExit:'确认退出',
        confirmMsg:'您确认要退出登录吗?',
        confirm:'确认',
        cancel:'取消',
        darkMode:'深色模式'
    },
    options:{
        Title:'语言设置',
        Language:'语言'
    },
    organization:{
        Label:{
            Title:'组织管理',
            Name:'组织名称',
            InputName:'输入组织名称',
            IncludeExpired:'包含已锁定',
            Applications:"已授权的应用",
            CompanyName:'组织全称',
            CompanyCode:'组织编码',
            CompanyInfo:'组织信息',
            State:'省份',
            City:'城市',
            Street:'街道地址',
            Phone:'联系电话',
            Bank:'开户行',
            Account:'账户',
            TaxNumber:'税号',
            Warning:'即将到期',
            License:'持有的证书'
        },
        Button:{
            Renewal:'续费',
            Lock:'锁定',
            Unlock:'解锁',
        },        
        RenewalType:{
            Day:'天',
            Week:'周',
            Month:'月',
            Season:'季度',
            Year:'年'
        },        
        ApplicationGrid:{
            ApplicationName:'应用名称',
            ExpirationDate:'到期时间'
        },
        Authorize:{
            Title:'添加应用授权',
            ApplicationName:'应用名称',            
        },
        Message:{
            CompanyName:'请输入组织全称',
            State:'请输入省份',
            City:'请输入城市',
            Street:'请输入街道地址',
            Phone:'请输入联系电话',
            InvalidPhone:'请输入有效的电话号码',
            SelectApplicaiton:'请选择一个应用',
            ConfirmToLock:'确认要锁定该组织吗?',
            ConfirmToUnlock:'确认要解锁该组织吗?',
            ConfirmRenewal:'续费操作无法撤销,确认已核对完毕续费时长?',
            ConfirmAuthorize:'确认添加应用授权?',
            Bank:'请输入开户行',
            Account:'请输入银行账户',
            TaxNumber:'请输入税号',
            confirmCancelCreate:'确认要退出新建吗?',
            confirmCancelEdit:'确认要退出编辑吗?'
        }
    },
    global:{
        CopySuccess:'复制成功',
        CopyFailed:'复制失败',
        Refresh:'刷新',
        Add:'添加',
        Create:'新建',
        Modify:'修改',
        Edit:'编辑',
        Delete:'删除',
        Confirm:'确认',
        Cancel:'取消',
        Save:'保存',
        Export:'导出',
        RequestFailed:'发送请求失败!',
        ResponseFailed:'请求返回失败!',
        Yes:'是',
        No:'否',
        Disabled:'禁用',
        Normal:'正常'
    },
    license:{
        Label:{
            Title:'证书管理',
            Application:'应用名称',
            License:'证书编号',            
            IncludeInvalid:'包含停用',           
            ExpirationDate:'有效期至',
            Warning:'即将到期',
            Enable:'启用',
            Disable:'停用',
            Log:'日志',
            Create:'创建',
            Bind:'绑定',
            Unbind:'解绑',
            Owner:'持有人',
            LogDate:'记录时间',
            Action:'操作类型',
            Modify:'修改',
            Operator:'操作人',            
            Content:'操作内容',            
            ApplicationPlaceholder:'请选择一个应用',
            ExpirationDatePlaceholer:'请选择一个到期时间',
            OwnerPlaceholder:'请选择持证人',           
            Parallel:'最大绑定数', 
            Remark: "备注",
            Export:'导出组织记录',
            FilterCompanyName:'组织全称',
            FilterCompanyCode:'组织编码',
            FilterState:'省份',
            FilterCity:'城市',
            FilterValid:'状态',
            FilterAll:'全部',
            FilterEnabled:'启用',
            FilterLocked:'锁定',
            FilterCreateTime:'创建时间',
            FilterFrom:'起',
            FilterTo:'止'
        },
        Columns:{
            IpAdress:'IP地址',
            MachineCode:"设备码",
            BindTime:"绑定时间",
            Operate:"操作",
            License:'证书编号', 
            Owner:'持有人',
            Application:'应用名称',
            Statue:'绑定状态',
            CreateTime:'签发日期',
            ExpirationDate:'有效期至',
            Remark: "备注"
        },
        Message:{
            ConfirmDisable:'确认要停用此证书吗?',
            ConfirmEnable:'确认要启用此证书吗?',
            ConfirmUnbind:'确认要强制解绑此证书吗?',
            confirmCancelCreate:'确认要退出新建吗?',
            confirmCancelEdit:'确认要退出编辑吗?',
            ExportSuccess:'组织记录导出成功',
            ExportFailed:'组织记录导出失败'
        }
    },
    application:{
        Label:{            
            Title:"应用管理",
            AddApp:'新增应用',
            Version:'版本号',
            ApplicationName:'应用名称',
            ApplicationCode:'应用标识码',
            Operate:'操作',
            IsMandatory:'强制更新',
            UpdateDate:'上传时间',
            EffectiveTime:'生效时间',
            Content:'版本描述',
            Detail:'详情',
            Statue:'状态',
            Valid:'有效',
            Invalid:'失效',
            UpgradeLog:'更新记录',
            NewVersion:'上传新版本',
            FileList:'文件清单',
            EndPoint:'子系统节点',
            Logo:'应用图标',
            LogoLimit:'500kb 以内的jpg/png文件',
            UseLicense:'使用证书激活',
            Random:'自动生成',
            Guid:'唯一性标识',
            Upgrade:'上传新版本',
            SelectFiles:'选择文件',
            FileName:'文件名',
            AccessTime:'最后修改日期',
            SelectDateTime:'选择一个时间',
            Download:'点击下载'
        },
        Message:{
            ApplicationName:'请输入应用名称!',
            ApplicationCode:'请指定应用标识码!',
            Uuid:'请输入一个合法的uuid',
            DeleteApplication:'确定要删除应用吗?删除后无法恢复!',
            
            ConfirmCreate:'应用标识码一经保存无法修改,是否已确认无误?',
            ConfirmCancel:'修改未保存,确认要取消吗?',
            Version:'请输入版本号',
            SelectFiles:'请选择要更新的文件',
            invalidUpgrade:'失效版本后无法恢复,请谨慎操作！确认要失效此版本吗?',
        },
        Error:{            
            Invalid_Version:'无效的版本号',
            UploadFailed_NoFile:'请选择文件',
            Invalid_Application:'无效的应用',
            Duplicate_ApplicationCode:'存在重复的应用表示码,请重新指定',
        }
    },
    personnel:{
        Label:{
            Title:'人员管理',
            Account:'账号',
            Password:'密码',
            Name:'姓名',
            Company:'组织/公司',
            Role:'角色权限',
            CreateTime:'创建时间',
            PhoneNumber:'手机号',
            Statue:'状态',
            Operate:'操作',
            Disabled:'禁用',
            Enabled:'启用',
            Modify:'修改',
            Reset:'重置密码'
        },      
        Message:{
            ConfirmDisabled:'确认禁用此用户吗?',
            ConfirmEnabled:'确认启用此用户吗?',
            ConfirmCancel:'修改未保存,确认要取消吗?',
            ConfirmReset:'确认要重置此用户的密码吗?新密码将通过邮件的方式发送.',
            ResetSuccess:'密码重置成功!'
        } ,
        Error:{
            Invalid_Account:'此用户不存在',
            Exsist_Account:'账号已存在',
            UnknownError_Account:'未知错误!当前用户不存在!',
            Failed_ResetPassword:'重置密码失败'
        }
    },
    role:{
        Subject:'学员',
        Coach:'教练员',
        Admin:'管理员',
        OM:'运维人员',
        SuperAdmin:'超级管理员'
    },
}